import {useEffect} from 'react';

// import { Link } from 'react-router-dom';

import ProfessionalTeam from './ProfessionalTeam';
import Track from './track';
// import Track from './track';
import Transportation from './Transportation';



const ProjectLogistics = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
  
  
    return(
        <div>
            <div id='international' className="project-Logistics-image">
                <img src='/project-logistics/Project-Logistics-Product-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] pb-[1rem]">
                <p>
                TCS Project Logistics takes care of shipment of heavy-load cargo and equipment that 
                present a multitude of unique challenges, such as excavator, bulldozer, generators, turbines, reactors, 
                boilers, towers, casting, heaters, presses, boats, satellites, and more.
                </p>
                <p>
                    With its cohesive logistics project management expertise, TCS provides a customised plan backed 
                    by a network of strategically placed logistics hubs and oversized freight vehicles to successfully 
                    administer the entire process. We ensure the use of most suitable routes, while advising customers 
                    throughout the project move.
                </p>
                <p>
                From involved costs and complexity to the common challenges we master with each project, TCS, with its 
                extensive knowledge of customs compliance, site logistics management, storage and warehousing and global
                freight forwarding experience, has unmatched capabilities when it comes to plan, move and re-instal 
                the most extensive of the projects.
                </p>
                
                
                
                 
            </div>

            <Track/>
            <ProfessionalTeam/>
            <Transportation/>
        </div>
    )
};
export default ProjectLogistics;